<template>
    <v-autocomplete
            hide-details
            :filled="filled"
            v-model="model"
            :items="items"
            item-text="name"
            item-value="id"
            :label="label || 'Seleccionar Servicio' + (isMultiple ? 's' : '')"
            prepend-inner-icon="fa-clipboard-list"
            @click:clear="clear"
            return-object
            :filter="filter"
            :multiple="isMultiple"
            :disabled="loading || disabled"
            :required="isRequired"
    >
        <template v-if="isMultiple" v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
                <span>{{ item.name }}</span>
            </v-chip>
            <span
                    v-if="index === 1"
                    class="grey--text caption"
            >({{ model.length - 1 }}+)</span>
        </template>

        <template slot="no-data">
               <span class="caption pa-2">No se han encontrado servicios</span>
        </template>

    </v-autocomplete>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {filterSelectorWithHeaders, filterUniqueIds} from '@/utils/Common'
    import {mapMutations} from 'vuex'

    export default{
        props: [
            'default',
            'multiple',
            'filterIds',
            'required',
            'serviceProviderId',
            'label',
            'disabled',
            'value',
            'onlyQuotable',
            'onlySchedulable',
            'mandatory',
            'type',
            'filled'
        ],
        data(){
            return {
                model: this.multiple !== undefined && this.multiple !== false ? [] : null,
                services: [],
                loading: false
            }
        },
        watch: {
            model(val, oldVal){
                var vm = this
                this.$emit('change', val)
                if(!vm.isMandatory) return
                if(!val || val.length === 0) this.model = vm.isMultiple  ? oldVal.slice() : oldVal
            },
            services(val){
                this.syncModelFromValue()
            },
            value(val){
                this.syncModelFromValue()
            }
        },
        mounted(){
            this.getServices()
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            filter: (item, queryText, itemText) => {

                if(typeof item.header !== 'undefined'){
                    return item.header.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
                }

                return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
            },
            clear(){
                this.model = this.isMultiple ? [] : null
            },
            selectedIds(selection){
                if(!selection) return []
                const items = Array.isArray(selection) ? selection : [selection]
                return items.map(item => {
                    return item && item.id !== undefined ? item.id.toString() : item.toString()
                }).sort()
            },
            sameSelection(nextModel){
                const vm = this
                const currentIds = vm.selectedIds(vm.model)
                const nextIds = vm.selectedIds(nextModel)

                return currentIds.length === nextIds.length &&
                    currentIds.every((id, index) => id === nextIds[index])
            },
            setModelIfChanged(nextModel){
                if(this.sameSelection(nextModel)) return
                this.model = nextModel
            },
            findItemById(selected){
                const vm = this
                const selectedId = selected && selected.id !== undefined ? selected.id : selected
                return vm.items.find(item => {
                    return !item.header && item.id.toString() === selectedId.toString()
                }) || selected
            },
            syncModelFromValue(){
                const vm = this
                const value = vm.value

                if(vm.isMultiple){
                    if(value && value.length > 0){
                        vm.setModelIfChanged(value.map(selected => vm.findItemById(selected)))
                        return
                    }

                    vm.setModelIfChanged([])
                    return
                }

                if(value){
                    vm.setModelIfChanged(vm.findItemById(value))
                    return
                }

                vm.setModelIfChanged(null)
            },
            async getServices(){

                var vm = this
                var url
                var filters = {}

                if (!vm.serviceProviderId) {
                    filters = {}
                    url = 'public/services/'
                }else{

                    if(vm.filterOnlyQuotable) filters.quotable = 1;
                    if(vm.filterOnlySchedulable) filters.schedulable = 1;

                    url = `public/provider/${vm.serviceProviderId}/services`
                }

                vm.loading = true
                var response = await ApiUtils.makeGet(url, filters)
                vm.loading = false

                if (!response.ok) {
                    vm.showSnackBar('Ha ocurrido un error consultando servicios')
                    return
                }

                const json = await response.json()

                vm.services = json.result.services
                vm.$emit('loaded', json.result.services)

            }
        },
        computed: {

            isMandatory(){
                var vm = this
                return vm.mandatory !== undefined && vm.mandatory !== false
            },

            isMultiple(){
                return this.multiple != undefined && this.multiple !== false
            },

            isRequired(){
              return this.required != undefined && this.required !== false
            },

            filterOnlyQuotable(){
                var vm = this
                return  !vm.filterOnlySchedulable && (vm.onlyQuotable === undefined || (vm.onlyQuotable && vm.onlyQuotable !== false))
            },

            filterOnlySchedulable(){
                var vm = this
                return vm.onlySchedulable !== undefined && vm.onlySchedulable !== false
            },

            items(){

                var vm = this
                var all = []

                if(!vm.services.length) return all

                var services = vm.type ? vm.services.filter(srv => srv.type === vm.type) : vm.services

                services.forEach((service) => {

                    all.push({
                        header: service.name
                    })

                    service.service_items.forEach((serviceItem) => {
                        all.push({
                            id: serviceItem.id,
                            name: serviceItem.description
                        })

                    })
                })

                if(vm.filterIds){
                    return all.filter(item => vm.filterIds.includes(item.id))
                }

                return all

            }
        }
    }
</script>
